import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config/apiClientConfig';

export const responseSchema = z.object({
	isSuccess: z.boolean(),
	encryptedJourneyId: z.string(),
	errorCode: z.number(),
});

const getIsOfflineSubmitted = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Member/:encryptedJourneyId/IsOfflineDataSubmitted',
		method: 'GET',
		responseSchema: responseSchema,
		requestParameters: {
			encryptedJourneyId: ['required', 'string'],
		},
	});

export type IsOfflineSubmittedResponse = TypeOfAPIResponse<ReturnType<typeof getIsOfflineSubmitted>>;

export type IsOfflineSubmittedError = TypeOfAPIError<ReturnType<typeof getIsOfflineSubmitted>>;

export default getIsOfflineSubmitted;
